import likesApi from "@/api/likes/nft/client";
import { User } from "@/api/users/types";
import { LikeEntity } from "../types";
import useLike from "./useLike";

interface Props {
  commentId: string;
  user: User | null | undefined;
}

const useNftCommentLike = ({ commentId, user }: Props) => {
  const isMeLiking = user?.nftCommentLikes.some(
    (like) => like.commentId === commentId,
  );

  return useLike({
    type: LikeEntity.NFT_COMMENT,
    entityId: commentId,
    likesApi: {
      getLikeCount: likesApi.getLikesFromNftComments,
      toggleLike: likesApi.toggleCommentLike,
    },
    isMeLiking,
  });
};

export default useNftCommentLike;
